import { useState, useCallback } from 'react';
import { TestResult, ArchetypeScores, Option } from '../types';
import { validateTestResult, validateAnswers, sanitizeTestData } from '../utils/testValidation';

export function useTestValidation() {
  const [errors, setErrors] = useState<string[]>([]);

  const validateAndSanitizeScores = useCallback((scores: ArchetypeScores) => {
    const sanitized = sanitizeTestData(scores);
    return sanitized;
  }, []);

  const validateTestData = useCallback((
    result: TestResult,
    answers: Option[]
  ): boolean => {
    const resultValidation = validateTestResult(result);
    const answersValidation = validateAnswers(answers);

    const allErrors = [
      ...resultValidation.errors,
      answersValidation.error
    ].filter((error): error is string => !!error);

    setErrors(allErrors);
    return allErrors.length === 0;
  }, []);

  const clearErrors = useCallback(() => {
    setErrors([]);
  }, []);

  return {
    errors,
    validateAndSanitizeScores,
    validateTestData,
    clearErrors,
    hasErrors: errors.length > 0
  };
}